/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

/*
 * action types
 */
export const GET_PAGE_TNC_DATA_REQUEST = "GET_PAGE_TNC_DATA_REQUEST";
export const GET_PAGE_TNC_DATA_SUCCESS = "GET_PAGE_TNC_DATA_SUCCESS";
export const GET_PAGE_TNC_DATA_FAILURE = "GET_PAGE_TNC_DATA_FAILURE";

/*
 * action creators
 */
export const getPageTncDataRequest = () => ({
  type: GET_PAGE_TNC_DATA_REQUEST
});

export const getPageTncDataSuccess = data => ({
  type: GET_PAGE_TNC_DATA_SUCCESS,
  data
});

export const getPageTncDataFailure = () => ({
  type: GET_PAGE_TNC_DATA_FAILURE
});



// WEBPACK FOOTER //
// ./src/actions/page.js